import Http from "@/utils/request.js";

// 搜索
export const MarketSearch = (data) => {
    return Http.request({
        url: "/stock/symbol/search",
        method: "post",
        data
    });
};

// 模糊搜索
export const MarketAssociativeSearch = (data) => {
    return Http.request({
        url: "/stock/fx-symbol/search/associativeSearch",
        method: "post",
        data
    });
};

// 行情列表
export const MarketList = (data) => {
    return Http.request({
        url: "/stock/symbol/list",
        method: "post",
        data
    });
};

// 行情分类
export const MarketClassify = (params) => {
    return Http.request({
        url: "/stock/market/all",
        method: "get",
        params
    });
};

// 美3行情分类
export const currencyAll = (data = {}) => {
    return Http.request({
        url: "/stock/merchant/paymentAccount2",
        method: "post",
        data
    });
};

// 首页行情
export const MarketHome = (data) => {
    return Http.request({
        url: "/stock/core/indexData",
        method: "post",
        data
    });
};

// 自选列表
export const MarketFollowList = (data) => {
    return Http.request({
        url: "/stock/keep/list",
        method: "post",
        data
    });
};

// 添加自选
export const MarketFollow = (id) => {
    return Http.request({
        url: "/stock/keep/addKeep",
        method: "get",
        params: {
            id
        }
    });
};

// 取消自选
export const MarketFollowCancel = (ids) => {
    return Http.request({
        url: "/stock/keep/bathRm",
        method: "get",
        params: {
            ids
        }
    });
};

// 自选状态
export const MarketFollowStatus = (id) => {
    return Http.request({
        url: "/stock/keep/isKeep",
        method: "get",
        params: {
            id
        }
    });
};

// 行情kline数据
export const MarketKLineList = (data) => {
    return Http.request({
        url: "/stock/symbol/klineList",
        method: "post",
        data
    });
};

// 下单
export const MarketPlaceOrder = (data) => {
    return Http.request({
        url: "/stock/core/entrust",
        method: "post",
        data
    });
};

// 下单信息
export const MarketPlaceOrderInfo = (code) => {
    return Http.request({
        url: `/stock/market/marketInfo`,
        method: "post",
        data: {
            code
        }
    });
};

// 详情
export const MarketDetail = (id) => {
    return Http.request({
        url: `/stock/core/tradePanelData`,
        method: "post",
        params: {
            id
        }
    });
};

// 当前持仓
export const MarketCurrentPosition = (market) => {
    return Http.request({
        url: `/stock/position/list`,
        method: "post",
        data: {
            market
        }
    });
};

// 虚拟持仓
export const MarketCurrentVirtualPosition = (market) => {
    return Http.request({
        url: `/stock/position/vrList`,
        method: "post",
        data: {
            market
        }
    });
};

// 止盈止损修改
export const MarketPositionEdit = (data) => {
    return Http.request({
        url: `/stock/core/editPosition`,
        method: "post",
        data
    });
};

// 历史持仓
export const MarketPositionHistory = (data) => {
    return Http.request({
        url: `/stock/position/history`,
        method: "post",
        data
    });
};

// 订单
export const MarketOrder = (data) => {
    return Http.request({
        url: `/stock/order/list`,
        method: "post",
        data
    });
};

// 订单详情
export const MarketOrderDetail = (id) => {
    return Http.request({
        url: `/stock/order/byId`,
        method: "get",
        params: {
            id
        }
    });
};

// 取消订单
export const MarketOrderCancel = (id) => {
    return Http.request({
        url: `/stock/order/cancel`,
        method: "get",
        params: {
            id
        }
    });
};

// 历史盈亏
export const MarketOrderHistoryPL = (market) => {
    return Http.request({
        url: `/stock/position/historyPL`,
        method: "post",
        data: {
            market
        }
    });
};

// 日内交易申请
export const DayTardingApply = (data) => {
    return Http.request({
        url: `/stock/dayTrading/apply`,
        method: "post",
        data
    });
};

// 日内交易记录
export const DayTardingRecords = (data) => {
    return Http.request({
        url: `/stock/dayTrading/record`,
        method: "post",
        data
    });
};

// 日内交易持仓
export const DayTardingPosition = (data) => {
    return Http.request({
        url: `/stock/dayTrading/position`,
        method: "post",
        data
    });
};

// AI交易、大量交易历史盈亏统计
export const otherHistoryPositionPL = (market) => {
    return Http.request({
        url: `/stock/position/getStatistics`,
        method: "post",
        data: {
            market
        }
    });
};
